import {MarketMoversService} from "./service/MarketMoversService";
import {MarketMoversStore} from "./store/MarketMoversStore";

import Components from "./components";
import {MarketMoverModelFactory} from "./service/MarketMoverModelFactory";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.movers`;

    return angular.module(moduleName, [Components(moduleName)])
                  .service(MarketMoversService.id, MarketMoversService)
                  .service(MarketMoverModelFactory.id, MarketMoverModelFactory)
                  .service(MarketMoversStore.id, MarketMoversStore)
                  .name;
}
